import Vue from 'vue';
import Router from 'vue-router';
import booking from './booking';
import johnsInfo from './johnsInfo';
import user from './user';
import other from './other';
// eslint-disable-next-line
import Home from '@/views/home/index.vue';
import Pic from '@/views/home/pic.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/pic',
    name: 'pic',
    component: Pic,
  },
];

Vue.use(Router);

export default new Router({
  routes: [...routes, ...booking, ...johnsInfo, ...user, ...other],
});
